export default "/_next/static/5aa2143bfe1c308567a28b5179314540.png";